// Auto-refactored from translations.js on 2026-08-19
// Locale: de

const de = {
  wieMoeglich: {
    question: 'Wie ist das möglich?',
    answer: 'Wir haben die Wertschöpfungskette neu gedacht.'
  },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'Der STIG ROCK Weg',
    fazit: 'Durch die verkürzte Lieferkette entfallen die größten Kostenpositionen.',
    fazitBigPre: 'Dies ermöglicht einen Preisnachlass von bis zu',
    fazitBigValue: '80%',
    steps: [ 'Mine', 'Schleiferei', 'Zertifizierung', 'Endkunde' ]
  },
  nav: { language: 'Sprache', contact: 'Kontakt' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Eine einzigartige Möglichkeit',
    subtitle: 'Zukunftsorientierter Aufbau.',
    description: 'Zugang zu natürlichen Diamanten über das STIG ROCK System gewährt.',
    scroll: 'Scrollen, um zu entdecken'
  },
  disclaimer: {
    overline: 'Rechtlicher Hinweis',
    title: 'Disclaimer',
    paragraphs: [
      'Diese Präsentation dient lediglich der Information und stellt keine Finanz-, Anlage- oder Steuerberatung dar.',
      'STIG ROCK ist kein Finanzprodukt, sondern bezieht sich auf natürliche Diamanten als Sachwerte.',
      'Für Wertentwicklungen, Gewinne oder Erträge wird keine Garantie übernommen. Vergangene Entwicklungen sind keine Indikation für zukünftige Ergebnisse.',
      'Sämtliche dargestellte Berechnungen im Zusammenhang mit Provisionen sind lediglich beispielhaft und stellen ebenfalls keine Garantie dar.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'AUFGEBAUT', 'AUF STRUKTUR' ],
    body: 'STIG Group ist ein internationaler Konzern, aufgebaut auf Klarheit, Verantwortung und langfristigem Wert. Jede Marke, jedes Vorhaben und jede Partnerschaft folgt einem einzigen Standard — ohne Abkürzungen, ohne Ausnahmen.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'AUFGEBAUT', 'AUF STRUKTUR' ],
        body: 'STIG Group ist ein internationaler Konzern, aufgebaut auf Klarheit, Verantwortung und langfristigem Wert. Jede Marke, jedes Vorhaben und jede Partnerschaft folgt einem einzigen Standard — ohne Abkürzungen, ohne Ausnahmen.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'DIE WELT', 'EXKLUSIVER DIAMANTEN' ],
        body: 'STIG ROCK ist ein modernes Konzept der STIG Group, das hochwertige GIA-zertifizierte Diamanten mit transparenten Strukturen und einem exklusiven Kundenerlebnis verbindet. Klare Lösungspläne, professionelle Abwicklung und internationale Ausrichtung.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'INTERNATIONALER', 'DIAMANTENHANDEL' ],
        body: 'STIG International ist Teil der STIG Group und spezialisiert auf den internationalen Handel mit GIA-zertifizierten Diamanten. Fokus auf Qualität, Vertrauen und moderne Handelsstrukturen mit globalen Partnerschaften.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'VERANTWORTUNG', 'AB DER MINE' ],
        body: 'Ethical Mines steht für verantwortungsvollen Abbau, rückverfolgbare Herkunft und konfliktfreie Diamanten. Von der Mine bis zum Markt — lückenlose Dokumentation für Transparenz, Integrität und langfristige Verantwortung entlang der gesamten Lieferkette.'
      }
    ]
  },
  moeglichkeiten: {
    overline: 'Möglichkeiten',
    title: 'Möglichkeiten für den nachhaltigen Aufbau',
    subtitle: 'Herkömmliche Wege im Vergleich.',
    stigLine: 'Diamanten',
    stigDrawback: 'Reeller Wertspeicher',
    items: [
      {
        tag: 'Trading',
        name: 'Forex oder Krypto',
        drawback: 'höchst spekulativ, unberechenbar, komplex'
      },
      {
        tag: 'Aktien',
        name: 'Börsen-Handel',
        drawback: 'Schwankungsrisiko, benötigtes Wissen, Zeitaufwand'
      },
      {
        tag: 'Krypto',
        name: 'Handel',
        drawback: 'Volatilität, Regulierungsrisiko, Sicherheitslücken'
      }
    ]
  },
  chance: {
    overline: 'Diamanten',
    title: 'Die unterschätzte Chance',
    body: 'Diamanten zählen seit Jahren zu den wertstabilsten und chancenreichsten Anlageformen, doch bislang nutzten nur wenige dieses Potenzial.',
    callout: 'Mit STIG ROCK eröffnen wir erstmals allen den Zugang zu diesen außergewöhnlichen Möglichkeiten.'
  },
  wertentwicklung: {
    overline: 'Wertentwicklung 1995 — 2025',
    title: 'Eine Geschichte über Wert.',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamanten',
    diamondValue: '+185%',
    note: 'Entwicklung seit 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Hauptgründe',
    title: 'Sechs Gründe für Diamanten',
    lead: 'Diamanten sind reale Sachwerte, die unabhängig von Währungen und Finanzsystemen bestehen — und seit Jahrhunderten ihren Wert bewahren.',
    items: [
      {
        n: '01',
        title: 'Krisensichere Wertstabilität',
        body: 'Realer Sachwert — historisch werterhaltend über Jahrhunderte.'
      },
      {
        n: '02',
        title: 'Die ultimative Mobilität',
        body: 'Klein, leicht zu verstecken und zu transportieren.'
      },
      {
        n: '03',
        title: 'Diversifikation & Knappheit',
        body: 'Angebots-Engpässe und natürliche Limitation.'
      },
      { n: '04', title: 'Langfristiges Wachstum', body: '+185% seit 1995.' },
      {
        n: '05',
        title: 'Transparenz & Exklusivität',
        body: 'Die 4 Cʼs als Garantie: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Reserve der Königshäuser',
        body: 'Selbst Königshäuser nutzen Diamanten als Vermögensreserve.'
      }
    ]
  },
  markt: {
    overline: 'Marktvolumen',
    title: '99 — 108 Mrd. USD',
    sub: 'Handelsvolumen im Jahr 2025',
    unit: 'USD Mrd.',
    forecast: 'Prognose bis ~2032 / 2034: ca. 140 – 168 Mrd. USD bei moderatem Wachstum (~4 – 5 % p.a.).',
    source: 'Quelle: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Innovation',
    title: 'Eine Innovation. Weltweit zum ersten Mal.',
    body: 'STIG ROCK ist die erste Plattform weltweit, die es Menschen ermöglicht, im Diamantenmarkt zusätzlich zur Wertsteigerung ein passives Einkommen zu erzielen.',
    leadershipTag: 'Leadership · Kontakt',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'Register-Nr. DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'Über das Unternehmen',
    titleLines: [ 'INTERNATIONALE', 'STRUKTUR', 'KLARE VISION' ],
    body: 'STIG ROCK wurde gegründet, um den Diamantenmarkt transparenter, moderner und kundenorientierter zu gestalten — mit Fokus auf Vertrauen, Sicherheit und langfristige Struktur.'
  },
  sicherheit: {
    overline: 'Qualität & Sicherheit',
    title: 'Gemological Institute of America',
    headline: 'Zertifizierte Expertise für Ihre Diamanten.',
    p1: 'GIA steht für das Gemological Institute of America — das weltweit führende, unabhängige und gemeinnützige Institut für Diamantbewertung und Erfinder des globalen 4C-Standards (Carat, Clarity, Color, Cut).',
    p2: 'Ein GIA-Zertifikat garantiert die Echtheit und Natürlichkeit eines Diamanten sowie eine objektive, unbestechliche Dokumentation all seiner Qualitätsmerkmale.',
    p3: 'Für den Kunden bedeutet das maximale Sicherheit und Vertrauen: Er weiß genau, was er kauft, zahlt einen fairen, qualitätsgerechten Preis und besitzt einen weltweit anerkannten, wertstabilen und jederzeit wiederverkaufbaren Diamanten.',
    body: 'Zertifizierte Expertise für Ihre Diamanten. GIA steht für das Gemological Institute of America — das weltweit führende, unabhängige und gemeinnützige Institut für Diamantbewertung und Erfinder des globalen 4C-Standards (Carat, Clarity, Color, Cut). Ein GIA-Zertifikat garantiert die Echtheit und Natürlichkeit eines Diamanten sowie eine objektive, unbestechliche Dokumentation all seiner Qualitätsmerkmale. Für den Kunden bedeutet das maximale Sicherheit und Vertrauen: Er weiß genau, was er kauft, zahlt einen fairen, qualitätsgerechten Preis und besitzt einen weltweit anerkannten, wertstabilen und jederzeit wiederverkaufbaren Diamanten.',
    transparency: 'Jeder Diamant erfüllt höchste Qualitätsstandards und wird von renommierten Organisationen geprüft und zertifiziert. Jeder Stein ist einzigartig und erhält ein individuelles Zertifikat.'
  },
  kimberleySlide: {
    overline: 'Kimberley Prozess',
    title: 'Wir arbeiten nur mit konfliktfreien Diamanten.',
    body: 'Der Kimberley Process ist ein internationales Zertifizierungssystem, das den Handel mit Konfliktdiamanten verhindert. Jeder Stein von STIG ROCK ist lückenlos rückverfolgbar und stammt aus verantwortungsvoll zertifizierten Quellen.',
    sealAlt: 'Kimberley Process — Offizielles Siegel'
  },
  dualTimeline: {
    overline: 'DAS DUAL SYSTEM · VISUELL',
    title: 'Ein Kauf, zwei Wege.',
    intro: 'Dein Diamant liegt sicher — ein zweiter Unternehmensdiamant arbeitet.\n' +
      'Vier Handelszyklen pro Jahr generieren den Preisnachlass, ohne dass dein Diamant jemals gehandelt wird.',
    customer: {
      kicker: 'TIMELINE 1',
      title: 'STIG ROCK\nDer Kunde',
      sub: 'Von Rohprodukt bis\nzur Lieferung',
      purchase: 'Kauf',
      cut: 'Schliff',
      certify: 'Zertifizierung',
      delivery: 'Auslieferung'
    },
    stig: {
      kicker: 'TIMELINE 2',
      sub: 'Ein zweiter Unternehmensdiamant · vier Zyklen · aktiver Handel',
      cycleSteps: [ 'Kauf', 'Planung', 'Schliff', 'Verkauf' ],
      footerCycle: '4 × Kauf-Schliff-Verkauf',
      footerDiscount: 'Preisnachlass → Kunde'
    },
    summary: {
      stored: 'Diamant sicher verwahrt',
      cycles: 'Handelszyklen jährlich',
      months: 'Monate Laufzeit'
    }
  },
  zertifiziert: {
    overline: 'GIA · Zertifizierung',
    title: 'Zertifiziert und transparent',
    body: 'Jeder Diamant erfüllt höchste Qualitätsstandards und wird von renommierten Organisationen geprüft und zertifiziert. Jeder Stein ist einzigartig und erhält ein individuelles Zertifikat.',
    kimberley: 'Kimberley Prozess — wir arbeiten ausschließlich mit konfliktfreien Diamanten.'
  },
  plaene: {
    overline: 'Solution Pläne (SP)',
    title: 'Eine einzigartige Produktinnovation',
    sub: 'Sieben Solution Pläne — von $250 bis $100K+,\n' +
      'jeweils mit steigendem Rabatt pro Monat und über die gesamte Laufzeit.',
    recommended: 'Beliebt',
    oneYear: '1 Jahr',
    rowLabels: {
      delivery: 'Lieferzeit',
      price: 'Produkt Preis',
      carat: 'Karat',
      monthly: 'Rabatt (Monat)',
      totalDiscount: 'Rabatt (Total)',
      duration: 'Laufzeit'
    },
    headers: {
      plan: 'Plan',
      from: 'Ab',
      carat: 'Karat',
      monthly: 'Rabatt / Monat',
      total: 'Rabatt Total',
      duration: 'Laufzeit'
    },
    duration: '1 Jahr',
    footnote: 'Alle Preisangaben sind ohne Gewähr und abhängig von Qualität, Nachfrage und aktueller Marktentwicklung.'
  },
  plaeneVIP: {
    overline: 'Solution Pläne + VIP-Paket',
    title: 'Mehr Vorteile mit dem VIP-Paket',
    sub: 'Kombiniere deinen Solution Plan mit einem VIP-Paket und profitiere von zusätzlichen Preisvorteilen von bis zu 3 %. So erhöhst du deinen Gesamtrabatt und sicherst dir noch attraktivere Konditionen.',
    rowLabels: {
      delivery: 'Lieferzeit',
      price: 'Produkt Preis',
      carat: 'Karat',
      monthly: 'Rabatt (Monat)',
      totalDiscount: 'Rabatt (Total)',
      vip1: 'VIP Paket 1 (+1%)',
      vip2: 'VIP Paket 2 (+2%)',
      vip3: 'VIP Paket 3 (+3%)'
    },
    footnote: 'Alle Preisangaben sind ohne Gewähr und abhängig von Qualität, Nachfrage und aktueller Marktentwicklung.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Kunde entscheidet, ob Lieferung oder Verkauf seines Diamanten!',
    sub: 'Nach Ablauf deines Solution Plans kannst du dir deinen Diamanten nach Hause liefern lassen, oder diesen wieder verkaufen.',
    options: [
      {
        key: 'deliver',
        title: 'Liefern lassen',
        body: 'Diamanten (Karat) zum Preis deines Solution Plans.'
      },
      {
        key: 'sellToUs',
        title: 'An uns verkaufen',
        body: 'Du kannst deine Diamanten an uns zum von dir bezahlten Kaufpreis zurückverkaufen.'
      },
      {
        key: 'sellThirdParty',
        title: 'Privat frei am Markt veräußern',
        body: 'Der Kunde kann den Diamanten selbst am Markt veräußern!'
      },
      {
        key: 'offer',
        title: 'Automatisches Kaufangebot',
        body: 'Kaufangebot 4 Wochen vor Lieferung — erscheint automatisch vor Ablauf des Solution Plans!'
      }
    ],
    footnote: '*DS-Plan steht für Solution Plan.'
  },
  tradWeg: {
    overline: 'Traditioneller Handel',
    title: 'Der traditionelle Weg',
    sub: 'Bevor ein Diamant den Endkunden erreicht, entstehen durch Zwischen-, Groß- und Einzelhandel erhebliche Handelsspannen, gegenüber dem Rohdiamantenpreis aus der Mine.',
    steps: [
      { title: 'Mine', subtitle: 'Rohdiamanten' },
      { title: 'Zwischen-Händler', subtitle: 'Rohdiamanten Einkauf' },
      { title: 'Schleiferei', subtitle: 'Schliff zum Anlagediamanten' },
      { title: 'Zertifizierung', subtitle: 'durch anerkannte Institute wie GIA' },
      { title: 'Diamanten Börse', subtitle: 'Verkauf an Großhandel' },
      { title: 'Großhandel', subtitle: 'Verkauf an Einzelhandel' },
      { title: 'Einzelhandel', subtitle: 'z. B. Juweliere' },
      { title: 'Endkunden', subtitle: 'Kauf von Diamanten' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'Das Dual System',
    sub: 'Ein Kauf. Zwei Diamanten. Doppelte Wertschöpfung.',
    duration: '1 Kauf = 2 Diamanten = Doppelte Wertschöpfung',
    centerBig: '5',
    centerCaption: 'Beispiel: 10.000 $ Kauf = 20.000 $ Gesamtwert',
    cycle: [
      {
        n: '1.',
        title: 'Kundenkauf',
        body: 'Kunde kauft Diamant mit Prozesszeit, z. B. 10.000 $.'
      },
      {
        n: '2.',
        title: 'Dual-Zuordnung',
        body: 'Sofort & zeitgleich: 1 Rohdiamant für den Kunden – 100 % sein Eigentum. 1 Rohdiamant für das Unternehmen.'
      },
      {
        n: '3.',
        title: 'Wertschöpfung',
        body: 'Fertiger Verkaufswert beider Diamanten: 20.000 $ – im Sortiment.'
      },
      {
        n: '4.',
        title: 'Aktiver Handel',
        body: 'Mit dem Unternehmensdiamanten wird sofort gearbeitet und gehandelt.'
      },
      {
        n: '5.',
        title: 'Weitere Einnahmen',
        body: 'Gewinne fließen in Minenlizenzen, den Abbau der Rohdiamanten und den Ankauf – STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rohdiamanten' },
      { title: 'Schleiferei', subtitle: 'durch unsere Partner' },
      { title: 'Zertifizierung', subtitle: 'durch anerkannte Institute' },
      { title: 'Endkunden', subtitle: 'Kauf & Rabattgutschriften' }
    ],
    footnote: 'Rohdiamant: STIG Ethical Mines · Veredelung bis Verkauf: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP-Pakete',
    sub: 'Gültig für 12 Monate auf alle von dir gezeichneten Solution Pläne. Je nach VIP-Paket: +1% bis +3% zusätzlicher Rabatt. Es ist nur 1 VIP Paket für alle laufenden Solution Pläne nötig.',
    cardKicker: 'zusätzlich – auf alle',
    cardKicker2: 'Solution Pläne',
    tip: 'Empfehlung: Ab $2.800 Investitionsvolumen lohnt sich VIP-Paket 3 am meisten.',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Aus Rabatten werden Ersparnisse',
      body: 'Monatliche Ersparnis statt monatlicher Belastung.\n' +
        'Aus Rabatten entstehen Ersparnisse – und diese bezahlen genau die Dinge, für die du sonst jeden Monat aus eigener Tasche zahlst.',
      line1Label: 'DS-Plan ab',
      line1Value: '$5.000',
      line2Label: 'mon. Rabatt',
      line2Value: '3%',
      line3Label: 'VIP-Paket 3',
      line3Value: '+3%',
      resultLabel: 'mon. Ersparnisse',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Wie ist das möglich?',
    title: 'Wir haben die Wertschöpfungskette neu gedacht.',
    traditionalTitle: 'Der traditionelle Weg',
    totalLabel: 'Endkundenpreis',
    traditionalSteps: [
      'Mine — Rohdiamanten',
      'Zwischen-Händler — Einkauf',
      'Schleiferei — Schliff',
      'Zertifizierung (GIA)',
      'Diamantenbörse — Großhandel',
      'Großhandel → Einzelhandel',
      'Juweliere → Endkunde'
    ],
    traditionalNote: 'Bevor ein Diamant den Endkunden erreicht, entstehen durch Zwischen-, Groß- und Einzelhandel erhebliche Handelsspannen.',
    stigTitle: 'Der STIG ROCK Weg',
    stigSteps: [
      'Direkter Kauf — Rohdiamanten aus der Mine',
      'Schleifen & Zertifizieren durch unsere Partner',
      'Verkauf an Endkunden & B2B Kunden'
    ],
    stigNote: 'Wir durchbrechen den Kreislauf und geben die Handelsspannen als Rabattgutschriften an unsere Kunden weiter.'
  },
  optionen: {
    overline: 'Deine Möglichkeiten',
    title: 'Nach Ablauf deines Solution Plans',
    items: [
      { title: 'Liefern lassen', body: 'Diamanten (Karat) zum Preis deines DS-Plans.' },
      { title: 'An uns verkaufen', body: 'Rückverkauf zum von dir bezahlten Kaufpreis.' },
      { title: 'An Dritte verkaufen', body: 'Diamanten am freien Markt veräußern.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution Pläne — eine einzigartige Produktinnovation',
    title: 'Der einfache Weg',
    caption: '3 · Schritte · zum Erfolg',
    captionParts: { count: '3', middle: 'Schritte', end: 'zum Erfolg' },
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Anmeldung',
        body: 'Kontaktiere deinen Empfehlungsgeber und erstelle ein kostenloses Benutzerkonto!'
      },
      { n: '02', icon: 'cart', title: 'Kauf eines Produkts', body: 'Bereits ab $ 250,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Rabatte erhalten',
        body: 'Erhalte monatliche Rabattgutschriften.'
      }
    ]
  },
  business: {
    overline: 'Bonusarten',
    title: 'Der einfachste und fairste Weg.',
    sub: 'Fünf Bonus-Arten — für deinen erfolgreichen Geschäftsaufbau.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Bis Level 3 — schon ab Level 1 aktiv.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Ab Sapphire — unendlich tief.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Auf den Infinity Bonus – bis Level 5 · OHNE Qualifikation.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 Pools des weltweiten Umsatzes.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Einmalbonus in Diamanten (Karat).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Dieser Bonus wird dir für jeden neu gezeichneten Solution Plan bis in das 3. Level bezahlt. Mit sehr geringen Qualifikationen schaltest du die einzelnen Levels frei.',
    total: 'Bis zu 18% Unilevel Bonus',
    totalParts: { prefix: 'Bis zu', big: '18%', suffix: 'Unilevel Bonus' },
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: 'von Anfang an',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: 'ab Karrierestufe Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: 'ab Karrierestufe Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'Ab der Karrierestufe Sapphire bist du für unseren Infinity Bonusplan qualifiziert. Du erhältst 3% Bonus. Mit jeder neuen Karrierestufe kommen weitere Prozente hinzu. Ist ein Partner in deinem Team ebenfalls qualifiziert, erhältst du die Differenz von Rang zu Rang.',
    exampleTitle: 'Beispiel',
    exampleRows: [
      { label: 'Du bist Blue Diamond', value: '12%' },
      { label: 'Dein Partner ist Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Dein Infinity Bonus', value: '9%' },
    totalNote: 'Gesamt bis zu 24% Infinity Bonus auf alle gezeichneten Solution Pläne in deinem Team — unendlich tief.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'Mit diesem Bonus profitierst du vom Erfolg deines Teams. Du erhältst einen Matching Bonus von 5% auf den Infinity Bonus deiner Partner — und das bis in die 5. Ebene deines Teams.',
    note: 'Auf alle Infinity Bonus-Zahlungen in deinem Team – bis in das 5. Level. Von Anfang an –\n' +
      'OHNE Qualifikation.',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: 'Gesamt bis zu',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '3% des weltweiten Umsatzes fließen zu gleichen Teilen in 3 verschiedene Pools.\n' +
      'Durch das Erreichen bestimmter Karrierestufen qualifizierst du dich für jeden einzelnen Pool.',
    forever: 'Einmal erreicht – für IMMER beteiligt!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'ab Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'ab Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'ab Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Gesamt',
    totalValue: '3%',
    totalSuffix: 'des weltweiten Umsatzes'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'Ab der Karrierestufe Diamond erhältst du einen Rang Bonus. Dieser wird in Diamanten (Karat) ausgezahlt. Hierbei handelt es sich um einen Einmalbonus.',
    highlight: 'Diamanten (Karat) im Gesamtwert von',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Karrierestufen',
    title: 'Karrierestufen',
    sub: 'Zur Erreichung der jeweiligen Karrierestufen zählt das historische Volumen (HV). Dieses muss ab Stufe Sapphire auf mehrere Teams verteilt sein (Verteilung**). Um Ruby oder höher zu erreichen, benötigst du mindestens zwei direkte Partner mit einem Solution Plan.',
    forever: 'Einmal erreicht – für IMMER bestätigt!',
    footnote: 'HV = Historisches Volumen. **Verteilung: max. Anteil eines Teams am HV.',
    distributionLabel: '**Verteilung:',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', dist: '', perks: [ '1 Unilevel' ] },
      {
        name: 'Pearl',
        coin: 'image83.png',
        hg: '250 HV',
        dist: '',
        perks: [ '2 Unilevels' ]
      },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        dist: '',
        perks: [ '2 dir. Pearl', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        dist: '60%',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        dist: '60%',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        dist: '50%',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        dist: '50%',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        dist: '40%',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        dist: '40%',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        dist: '30%',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        dist: '30%',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        dist: '25%',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        dist: '20%',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Starte mit uns durch',
    title: 'Die richtige Zeit ist genau jetzt.',
    body: 'Dieses Businessmodell setzt neue Maßstäbe und vereint alle Erfolgsfaktoren für ein langfristig nachhaltiges und erfolgreiches Geschäft. Registriere dich noch heute, wähle deinen Solution Plan und nutze diese einmalige Businesschance.',
    hint: 'Sprich mit der Person, die dich zu dieser Präsentation eingeladen hat — sie hat einen Registrierungslink für dich.',
    formName: 'Name',
    formEmail: 'E-Mail',
    formPhone: 'Telefon',
    formSubmit: 'Kontakt aufnehmen',
    success: 'Vielen Dank — wir melden uns diskret und persönlich.',
    callCta: 'Anrufen',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Rechtlicher Hinweis & Disclaimer',
    disclaimer: 'Diese Präsentation dient lediglich der Information und stellt keine Finanz-, Anlage- oder Steuerberatung dar. STIG ROCK ist kein Finanzprodukt, sondern bezieht sich auf natürliche Diamanten als Sachwerte. Für Wertentwicklungen, Gewinne oder Erträge wird keine Garantie übernommen. Vergangene Entwicklungen sind keine Indikation für zukünftige Ergebnisse. Sämtliche dargestellte Berechnungen im Zusammenhang mit Provisionen sind lediglich beispielhaft und stellen ebenfalls keine Garantie dar. Änderungen der Inhalte vorbehalten — freie Übersetzung (keine offizielle Übersetzung).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. Alle Rechte vorbehalten.',
    version: 'Version: DS-12-2025 V3'
  },
  misc: { next: 'Nächste Sektion' }
};

export default de;
